export enum constants {
    LANGUAGE = "eng",
    SELECTEDVALUE_2015 = "2015 or earlier",
    SELECTEDVALUE_C = "2016",
    SELECTEDVALUE_2017 = "2017",
    SELECTEDVALUE_2018 = "2018",
    DURATION = 10000,
    ACTION = "OK",
    KEY1 = "DependentDFPKQNAnswered",
    KEY2 = "pillar",
    TYPE = "table",
    CREATE = "create",
    UPDATE = "update",
    DELETE = "delete",
    MODIFIED = "modified",
    UNDEFINED = "undefined"
}
export enum KeyBoardCodes {
    DELETE = 46,
    ZERO = 48,
    NINE = 57,
    UNIT_SEPERATOR = 31
}
